import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useCompetitionStore } from '../../stores/competitionStore';
import { useTeamStore } from '../../stores/teamStore';
import { useAgreementStore } from '../../stores/agreementStore';

export default async function requireTeam(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void>
{
    if (await useAgreementStore().checkForPendingAgreements())
    {
        return next();
    }

    const teamId = useTeamStore().myTeamId || await useTeamStore().fetchMyTeamId();

    if (!teamId)
    {
        await useCompetitionStore().joinCompetition();
    }

    return next();
}